import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import { useGatewayCrmAutoRedirect } from "../../hooks/useGatewayCrmAutoRedirect";

type Props = {
    integrationName: CrmIntegrationProvider;
};

export function CrmGatewayAutoRedirect({ integrationName }: Props): null {
    useGatewayCrmAutoRedirect(integrationName);

    return null;
}
